import {
  AUTH_SIGNIN,
  AUTH_SIGNOUT,
  AUTH_UPDATE
} from '../actions/auth_actions';

const authReducer = (state = {
  name: '',
  role: '',
  id: '',
  authenticated: false

}, action) => {
  switch (action.type) {
    case AUTH_SIGNIN:
      return Object.assign({}, state, {
        authenticated: true
      });
    case AUTH_SIGNOUT:
      return Object.assign({}, state, {
        authenticated: false,
        role: '',
        name: '',
        id: ''
      });
      case AUTH_UPDATE:
      return Object.assign({}, state, {
        role: action.role,
        name: action.name,
        id: action.id
      });
    default:
      return state;
  }
}

export default authReducer


// WEBPACK FOOTER //
// ./src/reducers/auth_reducer.js